"use client";
import { useAppDispatch, useAppSelector } from "../../lib/redux/hooks";
import { changeProfile, selectProfile } from "../../lib/redux/resumeSlice";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";

export const ProfileForm = () => {
  const dispatch = useAppDispatch();
  const profile = useAppSelector(selectProfile);

  const handleProfileChange = (field: keyof typeof profile, value: string) => {
    dispatch(changeProfile({ field, value }));
  };

  return (
    <Card className="bg-white border-2 border-gray-800 shadow-lg">
      <CardHeader className="bg-gray-900 text-white">
        <CardTitle className="text-lg font-semibold">Personal Information</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label htmlFor="name" className="text-black font-semibold">Full Name</Label>
            <Input
              id="name"
              value={profile.name}
              onChange={(e) => handleProfileChange("name", e.target.value)}
              placeholder="John Doe"
              className="border-2 border-gray-300 bg-white text-black placeholder-gray-500 hover:border-black focus:border-black transition-colors"
            />
          </div>
          
          <div className="space-y-2">
            <Label htmlFor="email" className="text-black font-semibold">Email</Label>
            <Input
              id="email"
              type="email"
              value={profile.email}
              onChange={(e) => handleProfileChange("email", e.target.value)}
              placeholder="john.doe@example.com"
              className="border-2 border-gray-300 bg-white text-black placeholder-gray-500 hover:border-black focus:border-black transition-colors"
            />
          </div>
          
          <div className="space-y-2">
            <Label htmlFor="phone" className="text-black font-semibold">Phone</Label>
            <Input
              id="phone"
              value={profile.phone}
              onChange={(e) => handleProfileChange("phone", e.target.value)}
              placeholder="+1 (555) 123-4567"
              className="border-2 border-gray-300 bg-white text-black placeholder-gray-500 hover:border-black focus:border-black transition-colors"
            />
          </div>
          
          <div className="space-y-2">
            <Label htmlFor="location" className="text-black font-semibold">Location</Label>
            <Input
              id="location"
              value={profile.location}
              onChange={(e) => handleProfileChange("location", e.target.value)}
              placeholder="San Francisco, CA"
              className="border-2 border-gray-300 bg-white text-black placeholder-gray-500 hover:border-black focus:border-black transition-colors"
            />
          </div>
          
          <div className="space-y-2 md:col-span-2">
            <Label htmlFor="url" className="text-black font-semibold">Website/LinkedIn</Label>
            <Input
              id="url"
              value={profile.url}
              onChange={(e) => handleProfileChange("url", e.target.value)}
              placeholder="https://linkedin.com/in/johndoe"
              className="border-2 border-gray-300 bg-white text-black placeholder-gray-500 hover:border-black focus:border-black transition-colors"
            />
          </div>
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="summary" className="text-black font-semibold">Professional Summary</Label>
          <Textarea
            id="summary"
            value={profile.summary}
            onChange={(e) => handleProfileChange("summary", e.target.value)}
            placeholder="Experienced software engineer with 5+ years of expertise in full-stack development..."
            rows={4}
            className="border-2 border-gray-300 bg-white text-black placeholder-gray-500 hover:border-black focus:border-black transition-colors resize-none"
          />
        </div>
      </CardContent>
    </Card>
  );
};
